// extracted by mini-css-extract-plugin
module.exports = {"submitFormModal":"SubmitFormModal_submitFormModal__v6lot","input":"SubmitFormModal_input__ukQ6G","btn":"SubmitFormModal_btn__b7dse"};